<style lang="css"></style>

<template>
  <div>
    <modal title="退货" v-model="showModal">
      <i-form :label-width="80">
        <Form-item label="商品">{{ formValidate.name }}</Form-item>
        <Form-item label="网点">{{ formValidate.station }}</Form-item>
        <Form-item label="数量">
          <Input-number :min="0" v-model="formValidate.num"></Input-number>
        </Form-item>
        <Form-item label="单价">{{ formValidate.cost }}</Form-item>
        <Form-item label="总金额">
          <div>{{ total }}</div>
        </Form-item>
      </i-form>
      <div slot="footer">
        <i-button @click="close">取消</i-button>
        <i-button type="primary" @click="ok">确认</i-button>
      </div>
    </modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showModal: false,
      formValidate: {
        name: '',
        station: '',
        num: 1,
        cost: 1,
      },
    };
  },
  computed: {
    total() {
      let { num, cost } = this.formValidate;
      return (num * cost).toFixed(2);
    },
  },
  mounted() {},
  methods: {
    close() {
      this.showModal = false;
    },
    ok() {
      let { id, num } = this.formValidate;
      if (num) {
        this.$http
          .post('product/delivery/cancel', {
            id,
            num,
          })
          .then(({ data }) => {
            if (data.msg === 'ok') {
              this.$Message.success('退货成功!');
              this.showModal = false;
              this.$emit('finish');
            } else this.$Message.error('退货失败' + data.msg);
          });
      } else {
        this.$Message.error('数量必须大于0!');
      }
    },
    show(doc) {
      this.formValidate = doc;
      this.showModal = true;
    },
  },
};
</script>
